<template>
  <Dialog
    v-model:visible="visible"
    modal
    class="p-dialog--modal"
    @hide="onHide"
    :closable="false"
    :close-on-escape="false"
  >
    <template #header>
      <div class="modal-header">
        <div class="modal-header__text">
          <div class="modal-header__title">
            <slot name="title"></slot>
          </div>
          <div class="modal-header__description">
            <slot name="description"></slot>
          </div>
        </div>

        <Button @click="closeModal()" class="p-dialog-wizard--close-button">
          <IconModalClose />
        </Button>
      </div>
    </template>

    <template #closeicon>
      <IconModalClose />
    </template>

    <LoadingModal v-if="loading" />

    <div class="modal-body" v-if="!loading">
      <slot name="body"></slot>
    </div>

    <template #footer>
      <slot name="footer"></slot>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { Button, Dialog } from 'primevue';

import LoadingModal from '../global/LoadingModal.vue';

import IconModalClose from '@/icons/modal/ModalClose.svg?component';

defineProps<{
  loading: boolean;
}>();

const visible = defineModel<boolean>('visible');

const emit = defineEmits(['onClose', 'onHide']);

const closeModal = () => {
  emit('onClose');
};

const onHide = () => {
  emit('onHide');
};
</script>
